<template>
  <div class="global-content-box global-content-flex">
    <y-menu-title />
    <!-- 顶部搜索区域 -->
    <div class="global-mb16">
      <y-form
        class="search-form"
        :formInfo="formInfo"
        @search="search"
        @selfReset="reset"
      >
        <template #platform>
          <y-shop-by-platform
            ref="yShopByPlatformRef"
            :shopData="shopData"
            @change="shopChange"
          ></y-shop-by-platform>
        </template>
        <template #buttonOut>
          <span class="tip">只查询最近一个月的数据</span>
        </template>
      </y-form>
    </div>
    <!-- 活动列表 -->
    <div class="global-felx-1">
      <y-table
        :tableData="tableData"
        tooltip-effect="dark"
        :loading="talbeLoading"
        :tableInfo="tableInfo"
        :pageInfo="{
          pageNum: formDataList.pageNum,
          pageSize: formDataList.pageSize,
          total: total,
        }"
        @handlePage="handlePage"
      >
        <template #refundAmountHeader>
          <span>订单已退款金额</span>
          <el-tooltip content="获取实时退款金额" placement="top">
            <i @click="refresh" class="el-icon-refresh-right refresh-icon"></i>
          </el-tooltip>
        </template>
        <template #platform="scope">
          <span> {{ $getPlatformNameByValue(scope.row.platform) }} </span>
        </template>
        <template #scoresWaitSendStatus="scope">
          <span v-if="scope.row.scoresWaitSendStatus == 0">待发放</span>
          <span v-else-if="scope.row.scoresWaitSendStatus == 1">发放中</span>
          <span v-else-if="scope.row.scoresWaitSendStatus == 2">发放完成</span>
          <span v-else-if="scope.row.scoresWaitSendStatus == 3"
            >订单有部分退货</span
          >
          <span v-else-if="scope.row.scoresWaitSendStatus == 4"
            >订单已全部退货</span
          >
          <span v-else-if="scope.row.scoresWaitSendStatus == -1">未知异常</span>
          <span v-else-if="scope.row.scoresWaitSendStatus == -2"
            >待发放流程执行报错</span
          >
        </template>
      </y-table>
    </div>
  </div>
</template>

<script>
import { getPendingIntegralList } from "@/api/memberMessageSystem";
import { isScoresBindList } from "@/api/integralCenter/newMemberSystem";
export default {
  name: "pendingIntegralList",
  components: {},
  data() {
    return {
      total: 0,
      formDataList: {
        platform: "",
        sellerManageId: "", //店铺ID
        orderId: "", //主订单ID
        memberId: null, //会员ID
        orderFinishStartTime: "",
        orderFinishEndTime: "",
        waitSendStartTime: "",
        waitSendEndTime: "",
        pageSize: 10,
        pageNum: 1,
        queryType: 0,
      },
      talbeLoading: false,
      tableData: [],
      formInfo: [
        {
          prop: "platform",
          label: "平台名称：",
          slot: "platform",
        },
        {
          label: "主订单ID：",
          prop: "orderId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "全渠道会员ID：",
          prop: "memberId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "订单完成时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "orderFinishStartTime",
          endKey: "orderFinishEndTime",
          pickerOptionsStart: {
            disabledDate: (time) => {
              // 计算当前时间往前一个月的时间戳
              const oneMonthAgo = new Date();
              oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
              // 获取当前时间戳
              const now = Date.now();
              // 禁用早于一个月前的日期和晚于当前时间的日期
              return (
                time.getTime() < oneMonthAgo.getTime() || time.getTime() > now
              );
            },
          },
          pickerOptionsEnd: {
            disabledDate: (time) => {
              // 计算当前时间往前一个月的时间戳
              const oneMonthAgo = new Date();
              oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
              // 获取当前时间戳
              const now = Date.now();
              // 禁用早于一个月前的日期和晚于当前时间的日期
              return (
                time.getTime() < oneMonthAgo.getTime() || time.getTime() > now
              );
            },
          },
        },
        {
          label: "积分待发送时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "waitSendStartTime",
          endKey: "waitSendEndTime",
        },
      ],
      tableInfo: [
        {
          prop: "memberId",
          label: "全渠道会员ID",
          width: "150px",
        },
        {
          prop: "platform",
          label: "平台",
          slot: "platform",
        },
        {
          prop: "shopTitle",
          label: "店铺名称",
        },
        {
          prop: "orderId",
          label: "主订单ID",
        },
        {
          prop: "orderPayment",
          label: "实付金额（元）",
          align: "right",
        },
        {
          prop: "refundAmount",
          label: "订单已退款金额",
          align: "right",
          slotHead: "refundAmountHeader",
        },
        {
          prop: "orderFinishTime",
          label: "订单完成时间",
        },
        {
          prop: "scoresWaitSendTime",
          label: "积分待发送时间",
        },
        {
          prop: "scoresWaitSendStatus",
          label: "当前状态",
          slot: "scoresWaitSendStatus",
        },
        {
          prop: "scoresSendTime",
          label: "积分已发放时间",
        },
      ],
      shopData: [],
    };
  },
  created() {
    this.buriedPoint(1, "忠诚度管理", "会员信息管理", "待发放积分");
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
  },
  mounted() {
    // 获取成长值列表
    this.getActivityList();
    this.getScoresBindList();
  },
  methods: {
    shopChange(platform, shop) {
      this.formDataList.platform = platform;
      this.formDataList.sellerManageId = shop;
    },
    search(obj) {
      for (const key in obj) {
        if (key != "platform") {
          this.formDataList[key] = obj[key];
        }
      }
      this.formDataList.pageNum = 1;
      this.formDataList.pageSize = 10;
      this.getActivityList();
    },
    reset() {
      this.$refs.yShopByPlatformRef.reset();
    },
    // 获取店铺列表
    getScoresBindList() {
      let _param = {
        scoresCardId: this.MemberSystemInfo.scoresCardId,
        pageNum: 1,
        pageSize: 99,
      };
      isScoresBindList(_param).then((res) => {
        if (res.code == 200) {
          this.shopData = res.data.dataList.map((item) => {
            return {
              label: item.shopTitle,
              value: item.channelSellerManageId,
              platform: item.platform,
            };
          });
        }
      });
    },
    // 获取活动列表
    getActivityList(refresh = false) {
      this.talbeLoading = true;
      const query = {
        ...this.formDataList,
        scoresCardId: this.MemberSystemInfo.scoresCardId,
      };
      if (refresh) {
        query.queryType = 1;
      }
      getPendingIntegralList(query)
        .then((res) => {
          this.talbeLoading = false;
          if (res.code == 200) {
            this.tableData = res.data.dataList;
            this.total = res.data.pageInfo.total;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.talbeLoading = false;
        });
    },
    handlePage(page) {
      this.formDataList.pageNum = page.pageNum;
      this.formDataList.pageSize = page.pageSize;
      this.getActivityList();
    },
    // 刷新
    refresh() {
      this.getActivityList(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.tip {
  line-height: 30px;
}
.refresh-icon {
  margin-left: 8px;
  cursor: pointer;
}
.search-form {
  /deep/ .query-form {
    padding: 16px 0px 0 8px;
  }
}
</style>
